const handleDeleteServiceModalEquipService = {
  confirm: 'Do you really want to delete the service?',
  title: 'DELETE SERVICE'
};

export default handleDeleteServiceModalEquipService;
